// Button Component
class SizeChartButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        * {
          box-sizing: border-box;
        }

        .size-chart-button {
          background: transparent;
          cursor: pointer;
          font-size: 14px;
          font-family: inherit;
          border: none;
          padding: 0;
          margin-top: 10px;
          text-transform: uppercase;
        }
      </style>

      <button class="size-chart-button">Guía de tallas</button>
    `;
  }

  setupEventListeners() {
    const button = this.shadowRoot.querySelector('.size-chart-button');

    button.addEventListener('click', () => {
      const modal = document.querySelector('size-chart-modal');
      if (modal) {
        modal.open();
      }
    });
  }
}

// Modal Component
class SizeChartModal extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  getData() {
    const dataElement = document.getElementById('size-chart-data');
    if (dataElement) {
      try {
        return JSON.parse(dataElement.textContent);
      } catch (e) {
        console.error('Error parsing size chart data:', e);
        return null;
      }
    }
    return null;
  }

  render() {
    const data = this.getData();
    if (!data) return;

    this.shadowRoot.innerHTML = `
      <style>
        * {
          box-sizing: border-box;
        }

        .modal-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9999;
          justify-content: center;
          align-items: center;
        }

        .modal-overlay.active {
          display: flex;
        }

        .modal-content {
          background: white;
          padding: 0;
          max-width: 900px;
          width: 90%;
          max-height: 90vh;
          overflow: hidden;
          position: relative;
          border-radius: 0;
          display: flex;
        }

        .modal-left {
          flex: 1;
          display: flex;
          align-items: stretch;
          justify-content: center;
          overflow: hidden;
        }

        .modal-right {
          flex: 1;
          padding: 40px;
          overflow-y: auto;
        }

        .modal-close {
          position: absolute;
          top: 20px;
          right: 20px;
          background: transparent;
          border: none;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          z-index: 1;
        }

        .modal-close:hover {
          opacity: 0.7;
        }

        .modal-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .modal-title {
          font-size: 24px;
          font-weight: 500;
          margin: 0 0 10px 0;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .modal-subtitle {
          font-size: 14px;
          color: #666;
          margin: 0 0 20px 0;
        }

        .size-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: center;
          margin-bottom: 30px;
        }

        .size-button {
          background: white;
          border: 1px solid #ddd;
          padding: 8px 16px;
          cursor: pointer;
          font-size: 12px;
          transition: all 0.2s ease;
        }

        .size-button.active {
          border-color: #000;
        }

        .size-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .measurements-table {
          width: 100%;
          margin-bottom: 20px;
        }

        .measurement-row {
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #eee;
          font-size: 14px;
        }

        .measurement-row:last-child {
          border-bottom: none;
        }

        .measurement-label {
          font-weight: 500;
        }

        .measurement-value {
          color: #666;
        }

        .size-guide-link {
          text-align: center;
          font-size: 12px;
          text-decoration: underline;
          color: #000;
          cursor: pointer;
          margin-top: 20px;
        }

        @media (max-width: 768px) {
          .modal-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100dvh;
            max-width: 100vw;
            max-height: 100dvh;
            flex-direction: column;
            overflow-y: auto;
          }

          .modal-left {
            flex: 0 0 auto;
            height: 50vh;
            min-height: 300px;
          }

          .modal-right {
            flex: 1;
            padding: 30px 20px;
          }

          .modal-title {
            font-size: 20px;
          }

          .size-buttons {
            gap: 8px;
          }

          .size-button {
            padding: 6px 12px;
            font-size: 11px;
          }

          .size-image {
            object-fit: cover;
          }
        }
      </style>

      <div class="modal-overlay">
        <div class="modal-content">
          <button class="modal-close" aria-label="Cerrar">✕</button>

          <div class="modal-left">
            ${data.image ? `<img src="${data.image}" alt="Guía de tallas" class="size-image">` : ''}
          </div>

          <div class="modal-right">
            <div class="modal-header">
              <h2 class="modal-title">Guía de tallas</h2>
              <p class="modal-subtitle">Selecciona una talla</p>
            </div>

            <div class="size-buttons">
              ${data.size_chart.map((size, index) => `
                <button class="size-button ${index === 0 ? 'active' : ''}" data-index="${index}">
                  ${size.name}
                </button>
              `).join('')}
            </div>

            <div class="measurements-table" id="measurements">
              ${this.renderMeasurements(data.size_chart[0])}
            </div>

          </div>
        </div>
      </div>
    `;
  }

  renderMeasurements(sizeData) {
    return sizeData.measures.map(measure => `
      <div class="measurement-row">
        <span class="measurement-label">${measure.label}</span>
        <span class="measurement-value">${measure.measure}</span>
      </div>
    `).join('');
  }

  setupEventListeners() {
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    const closeButton = this.shadowRoot.querySelector('.modal-close');
    const sizeButtons = this.shadowRoot.querySelectorAll('.size-button');
    const measurementsContainer = this.shadowRoot.getElementById('measurements');
    const data = this.getData();

    const closeModal = () => {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    closeButton.addEventListener('click', closeModal);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeModal();
      }
    });

    sizeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);

        sizeButtons.forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');

        if (data && data.size_chart[index]) {
          measurementsContainer.innerHTML = this.renderMeasurements(data.size_chart[index]);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeModal();
      }
    });
  }

  open() {
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    const overlay = this.shadowRoot.querySelector('.modal-overlay');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

customElements.define('size-chart-button', SizeChartButton);
customElements.define('size-chart-modal', SizeChartModal);